import Vue from 'vue'
import Router from 'vue-router'
import ErrorPage from '@/components/ErrorPage'
import CGTrading from '@/components/CGTrading/Index'
import SuiSenAnti from '@/components/SuiSen/Index'
import SuiSenLoad from '@/components/SuiSen/Load'
import Demo from '@/components/MaiTeng/GoToMiniApp'
import AntiDemo from '@/components/Demo/Anti'
import MonTon from '@/components/MaiTeng/Index'
import MonTonStore from '@/components/MaiTeng/Store'
import FanXiang from '@/components/FanXiang/Index'
import KangMai from '@/components/KangMai/Index'
import HuaKu from '@/components/HuaKu/Index'
import HuaKuScan from '@/components/HuaKu/Scan'
import TianYi from '@/components/TianYi/Index'
import JiaTang from '@/components/JiaTang/Index'
import AntiDemoA from '@/components/Demo/AntiA'
import AntiDemoB from '@/components/Demo/AntiB'
import SaiKe from '@/components/SaiKe/Index'
import HuaKai from '@/components/HuaKai/Index'
import XinHengFeng from '@/components/XinHengFeng/Index'
import ZhuoMuNiao from '@/components/ZhuoMuNiao/Index'
import FuXiao from '@/components/FuXiao/Index'
import BoLangFeiLin from '@/components/BoLangFeiLin/Index'
import BoLangFeiLinScan from '@/components/BoLangFeiLin/Scan'
import BoLangFeiLinScore from '@/components/BoLangFeiLin/ScoreResult'
import Astaxin from '@/components/Astaxin/Index'
import YouLeMei from '@/components/YouLeMei/Index'
import YouLeMeiQuery from '@/components/YouLeMei/Query'
import KuaiMa from '@/components/KuaiMa/Index'
import KuaiMaQuery from '@/components/KuaiMa/Query'
Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/anti-demo',
      name: 'AntiDemo',
      component: AntiDemo,
      meta: {
        title: '防伪查询'
      }
    },
    {
      path: '/anti-demob',
      name: 'AntiDemoB',
      component: AntiDemoB,
      meta: {
        title: '防伪查询'
      }
    },
    {
      path: '/anti-demoa',
      name: 'AntiDemoA',
      component: AntiDemoA,
      meta: {
        title: '防伪查询'
      }
    },
    {
      path: '/demo',
      name: 'Demo',
      component: Demo,
      meta: {
        title: '测试页'
      }
    },
    {
      path: '/huakai',
      name: 'HuaKaiAnti',
      component: HuaKai,
      meta: {
        title: '防伪查询'
      }
    },
    {
      path: '/ylm',
      name: 'YouLeMeiAnti',
      component: YouLeMei,
      meta: {
        title: '防伪查询'
      }
    },
    {
      path: '/ylm.query',
      name: 'YouLeMeiAnti',
      component: YouLeMeiQuery,
      meta: {
        title: '防伪查询'
      }
    },
    {
      path: '/km',
      name: 'KuaiMa',
      component: KuaiMa,
      meta: {
        title: '快马工服 信息科技'
      }
    },
    {
      path: '/km.query',
      name: 'KuaiMa',
      component: KuaiMaQuery,
      meta: {
        title: '快马工服 信息科技'
      }
    },
    {
      path: '/fx',
      name: 'FuXiaoAnti',
      component: FuXiao,
      meta: {
        title: '防伪查询'
      }
    },
    {
      path: '/astaxin',
      name: 'AstaxinAnti',
      component: Astaxin,
      meta: {
        title: 'Verifieringsfråga'
      }
    },
    {
      path: '/saike',
      name: 'SaiKeAnti',
      component: SaiKe,
      meta: {
        title: '防伪查询'
      }
    },
    {
      path: '/suisen',
      name: 'SuiSenAnti',
      component: SuiSenAnti,
      meta: {
        title: '防伪查询'
      }
    },
    {
      path: '/bolang',
      name: 'BoLangAnti',
      component: BoLangFeiLin,
      meta: {
        title: '首页'
      }
    },
    {
      path: '/bolang/scan',
      name: 'BoLangAnti',
      component: BoLangFeiLinScan,
      meta: {
        title: '首页'
      }
    },
    {
      path: '/bolang/result',
      name: 'BoLangAnti',
      component: BoLangFeiLinScore,
      meta: {
        title: '防伪结果'
      }
    },
    {
      path: '/zmn',
      name: 'ZhuoMuNiao',
      component: ZhuoMuNiao,
      meta: {
        title: '首页'
      }
    },
    {
      path: '/xhf',
      name: 'XinHengFeng',
      component: XinHengFeng,
      meta: {
        title: '首页'
      }
    },
    {
      path: '/monton',
      name: 'MONTON',
      component: MonTon,
      meta: {
        title: '首页'
      }
    },
    {
      path: '/monton/storePage',
      name: 'MONTON',
      component: MonTonStore,
      meta: {
        title: '一店一码首页'
      }
    },
    {
      path: '/suisen/load',
      name: 'SuiSenLoad',
      component: SuiSenLoad,
      meta: {
        title: '加载中'
      }
    },
    {
      path: '/cgtrading',
      name: 'CGTradingIndex',
      component: CGTrading,
      meta: {
        title: '防伪查询'
      }
    },
    {
      path: '/fanxiang',
      name: 'FanXiangIndex',
      component: FanXiang,
      meta: {
        title: '防伪查询'
      }
    },
    {
      path: '/kangmai',
      name: 'KangMaiIndex',
      component: KangMai,
      meta: {
        title: '防伪查询'
      }
    },
    {
      path: '/huaku',
      name: 'HuaKuIndex',
      component: HuaKu,
      meta: {
        title: '防伪查询'
      }
    },
    {
      path: '/huaku/scan',
      name: 'HuaKuScan',
      component: HuaKuScan,
      meta: {
        title: '防伪查询'
      }
    },
    {
      path: '/tianyi',
      name: 'TianYiIndex',
      component: TianYi,
      meta: {
        title: '首页'
      }
    },
    {
      path: '/jiatang',
      name: 'JiaTangIndex',
      component: JiaTang,
      meta: {
        title: '防伪查询'
      }
    },
    {
      path: '/',
      name: 'ErrorPage',
      component: ErrorPage,
      meta: {
        title: '错误页'
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js